import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledLinkHeading = styled.div`
  display: flex;
  align-items: baseline;
  > h2 {
    flex-grow: 1;
  }
  .LinkHeading__link_wrapper {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 600;
  }
`;

const LinkHeading = ({ className, title, rightElement }) => {
  const classes = ['LinkHeading', className];
  return (
    <StyledLinkHeading className={classes.filter((c) => !!c).join(' ')}>
      <h2>{title}</h2>
      {rightElement}
    </StyledLinkHeading>
  );
};

LinkHeading.displayName = 'LinkHeading';

LinkHeading.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  rightElement: PropTypes.element,
};

LinkHeading.defaultProps = {
  className: null,
  rightElement: null,
};

export default LinkHeading;
